export const setPageTitle = (pageTitle: string): string => {
  return `${pageTitle}${window.Skooldio?.paymentConfig?.HTMLMeta?.pageTitleSuffix}`;
};
